import axios from 'axios';

// Cria a conexão base com o seu Back-end Node.js
const api = axios.create({
  baseURL: 'https://erp-maxtramidia-backend.onrender.com' // A porta onde seu back-end está rodando
  // baseURL: 'http://localhost:3333' // A porta onde seu back-end está rodando
  //   ,headers: {
  //   'ngrok-skip-browser-warning': 'true' // 👈 evita o aviso do ngrok
  // }
});

// "INTERCEPTOR" MÁGICO
// Toda vez que o Front-end for fazer uma requisição, ele passa por aqui antes.
// Ele pega o token de login salvo no navegador e coloca no cabeçalho (Header).
api.interceptors.request.use(
  (config) => {
    // Pegando o token que geralmente salvamos no localStorage ao fazer login
    const token = localStorage.getItem('@maxtramidia:token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
